module.exports = __webpack_public_path__ + "static/production-9e9a6eda1ed213302f4f60e306f5b1a6.svg";